import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import ReviewForm from "../Reviews/Reviewform";
import "../../../Assets/css/style.css";

const CompleteDeal = () => {
  const navigate       = useNavigate();
  const { id: dealId } = useParams();

  const [loading,     setLoading]     = useState(false);
  const [completed,   setCompleted]   = useState(false);
  const [showReview,  setShowReview]  = useState(false);

  // vendorId and vendorName should come from deal data
  // You can pass them via location.state when navigating to this page:
  // navigate(`/user/crm/complete/${deal.id}`, { state: { vendorId: deal.receiver_id, vendorName: deal.receiver_name } })
  const location    = window.history.state?.usr || {};
  const vendorId    = location.vendorId   || null;
  const vendorName  = location.vendorName || "Vendor";

  const completeDeal = async () => {
    setLoading(true);
    try {
      const res = await Handler({
        method: "POST",
        url:    "/mini_crm/complete.php",
        data:   { deal_id: parseInt(dealId) },
      });
      if (res.success) {
        toast.success("Deal marked as completed!");
        setCompleted(true);
        // If we have vendorId, show review form
        // Otherwise go straight to CRM list
        if (vendorId) {
          setShowReview(true);
        } else {
          navigate("/user/crm");
        }
      } else {
        toast.error(res.message || "Failed to complete deal");
      }
    } catch {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <FeedLayout>
        <div className="crm-page">

          {/* Header */}
          <div className="crm-header">
            <div>
              <h1 className="crm-title">Complete Deal</h1>
              <p className="crm-subtitle">Deal #{dealId} — Mark this deal as completed</p>
            </div>
            <button
              className="crm-btn crm-btn--outline"
              onClick={() => navigate("/user/crm")}
            >
              <i className="bx bx-arrow-back" /> Back
            </button>
          </div>

          {/* Complete Card */}
          <div className="crm-form-card crm-respond-card">
            <div className="crm-respond-icon crm-respond-icon--complete">
              <i className="bx bx-badge-check" />
            </div>
            <h3 className="crm-respond-title">Mark this deal as completed?</h3>
            <p className="crm-respond-desc">
              This action is irreversible. Once marked as completed, the deal
              will be closed and no further messages can be sent.
              {vendorId && (
                <><br /><br />
                  <span style={{ color: "#2563eb", fontWeight: 600 }}>
                    You'll be asked to rate the vendor after completing.
                  </span>
                </>
              )}
            </p>

            <div className="crm-respond-actions">
              <button
                className="crm-btn crm-btn--outline"
                onClick={() => navigate("/user/crm")}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="crm-btn crm-btn--complete"
                onClick={completeDeal}
                disabled={loading || completed}
              >
                {loading ? (
                  <><span className="crm-btn-spinner" /> Completing…</>
                ) : (
                  <><i className="bx bx-badge-check" /> Yes, Complete Deal</>
                )}
              </button>
            </div>
          </div>

        </div>

        {/* Review Modal — shown after deal is completed */}
        {showReview && vendorId && (
          <ReviewForm
            vendorId={vendorId}
            vendorName={vendorName}
            dealId={parseInt(dealId)}
            onClose={() => {
              setShowReview(false);
              navigate("/user/crm");
            }}
            onSuccess={() => navigate("/user/crm")}
          />
        )}

      </FeedLayout>
    </MainLayout>
  );
};

export default CompleteDeal;